import React from 'react'
import PropTypes from 'prop-types'

import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import activityBanksActions from 'redux/actions/activityBanksActions'
import { localize } from 'helpers/translator'

const ActivityReplaceConfirm = props => (
	<Confirm
		btOne={localize('activity_banks_replaceConfirm_backButton')}
		btTwo={localize('activity_banks_replaceConfirm_replaceButton')}
		alertMessage={localize('activity_banks_replaceConfirm_message')}
		alertTitle={localize('activity_banks_replaceConfirm_title')}
		actionButtonType={0}
		actionOne={props.actions.onCancel}
		actionTwo={() => props.actions.onConfirm(props.lesson)}
		closeAction={props.actions.onCancel}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		onConfirm: activityBanksActions.activitySelectedConfirmed,
		onCancel: activityBanksActions.activitySelectedCancelled,
	}, dispatch)
}

ActivityReplaceConfirm.propTypes = {
	actions: PropTypes.shape({
		onConfirm: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired,
	}),
	lesson: PropTypes.object,
}

ActivityReplaceConfirm.defaultProps = {
	lesson: {},
}

export default connect(null, mapDispatchToProps)(ActivityReplaceConfirm)

export { ActivityReplaceConfirm }
